import { Component, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { filter, takeUntil, take } from 'rxjs/operators';

@Component({
  selector: 'unh-dropdown-button',
  styleUrls: ['./dropdown-button.component.scss'],
  template: `
    <unh-input-group>
      <div class="dropdown-button__trigger" #trigger>
          <ng-content select="unh-button-old-container"></ng-content>
      </div>

      <div class="dropdown-button__menu" [hidden]="!showDropdownMenu">
          <ng-content select="unh-dropdown-list"></ng-content>
      </div>
    </unh-input-group>
  `
})
export class DropdownButtonComponent implements AfterViewInit, OnDestroy {
  private readonly _destroyButtonListener$ = new Subject();
  private readonly _destroyBodyListener$ = new Subject();
  private _showDropdownMenu = false;

  get showDropdownMenu() {
    this.listenOneClickOnDocument();
    return this._showDropdownMenu;
  }

  @ViewChild('trigger') triggerRef: ElementRef<HTMLElement>;

  ngAfterViewInit() {
    const triggerEl = this.triggerRef.nativeElement;

    fromEvent(triggerEl, 'click')
      .pipe(takeUntil(this._destroyButtonListener$))
      .subscribe(() => {
        this._showDropdownMenu = !this.showDropdownMenu;

        if (this.showDropdownMenu) {
          fromEvent(document.body, 'click').pipe(
            filter((e: any) => e.composedPath().some(evt => evt.classList && evt.classList.contains('dropdown-button__menu'))),
            takeUntil(this._destroyButtonListener$)
          ).subscribe();
        } else {
          this._destroyBodyListener$.next({});
          this._destroyBodyListener$.complete();
        }
      });
  }

  private listenOneClickOnDocument() {
    fromEvent(document.body, 'click').pipe(
      filter((e: any) => e.composedPath().some(evt => evt.classList && evt.classList.contains('dropdown-button__menu'))),
      take(1)
    ).subscribe();
  }

  ngOnDestroy() {
    this._destroyButtonListener$.next({});
    this._destroyButtonListener$.complete();
  }
}
